import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
			fill: "#00579F"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#52hzrxjbda)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M21.334 21.812h-3.24L20.12 9.228h3.24l-2.026 12.584zM33.08 9.536A7.956 7.956 0 0 0 30.172 9c-3.2 0-5.453 1.713-5.467 4.163-.027 1.808 1.613 2.812 2.84 3.414 1.253.616 1.68 1.018 1.68 1.567-.013.843-1.013 1.232-1.946 1.232-1.294 0-1.987-.2-3.04-.67l-.427-.2-.454 2.824c.76.348 2.16.657 3.614.67 3.4 0 5.614-1.687 5.64-4.298.013-1.432-.853-2.53-2.72-3.427-1.133-.576-1.827-.964-1.827-1.553.013-.536.587-1.084 1.866-1.084a5.486 5.486 0 0 1 2.414.482l.293.133.44-2.717zM37.386 17.354c.267-.723 1.294-3.52 1.294-3.52-.014.026.266-.737.426-1.205l.227 1.084s.613 3.012.747 3.641h-2.694zm4-8.126H38.88c-.773 0-1.36.228-1.694 1.044l-4.813 11.54h3.4l.68-1.888h4.16c.093.442.387 1.888.387 1.888h3L41.386 9.228zM15.387 9.228l-3.174 8.581-.346-1.74c-.587-2.008-2.427-4.19-4.48-5.275L10.293 21.8h3.427l5.093-12.57h-3.426z",
				fill: "#fff"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M9.267 9.228H4.053L4 9.482c4.067 1.045 6.76 3.562 7.867 6.588l-1.134-5.784c-.186-.804-.76-1.031-1.466-1.058z",
				fill: "#FAA61A"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "52hzrxjbda",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				transform: "translate(4 9)",
				d: "M0 0h40v13H0z"
			})
		}) })
	]
});
export default SvgVisa;
